/**
 * 组织架构部门导航
 */
import React, { useEffect } from 'react';
import arrowRightIcon from '../../images/app_ic_arrow_right.png';
var DeptCrumbItem = function (_a) {
    var name = _a.name, active = _a.active, first = _a.first, onClick = _a.onClick;
    useEffect(function () {
        // 让部门面包屑有滚动条时始终显示滚动条最后的内容
        var divscll = document.getElementById('dept-crumb');
        divscll.scrollLeft = divscll.scrollWidth;
    }, []);
    return (React.createElement("div", { className: "focus-user-selection-org-nav-item", onClick: function () {
            if (!active) {
                return false;
            }
            onClick();
        } },
        React.createElement("div", null,
            !first && React.createElement("img", { src: arrowRightIcon, alt: "", width: 10 }),
            React.createElement("div", { className: ['user-selection-item-text', active ? 'active' : ''].join(' '), style: {
                    cursor: active ? 'pointer' : '',
                    marginLeft: first ? 0 : 5,
                } }, name))));
};
export function DeptCrumb(_a) {
    var data = _a.data, onItemClick = _a.onItemClick;
    var list = data;
    useEffect(function () {
        var ele = document.getElementById('dept-crumb');
        if (ele) {
            ele.scrollIntoView(false);
        }
    }, []);
    return (React.createElement("div", { className: "dept-crumb", id: "dept-crumb" }, list.map(function (item, i) { return (React.createElement(DeptCrumbItem, { key: item.id, name: item.name, active: i < data.length - 1, first: i === 0, onClick: function () {
            onItemClick({
                id: item.id,
                nodeId: item.nodeId,
            });
        } })); })));
}
//# sourceMappingURL=DeptCrumb.js.map